export const handleUserAgentData = () => {
  const isWindows11 = async () => {
    if (navigator.userAgentData) {
      try {
        const ua = await navigator.userAgentData.getHighEntropyValues([
          'platformVersion'
        ])
        if (navigator.userAgentData.platform === 'Windows') {
          const majorPlatformVersion = parseInt(
            ua.platformVersion.split('.')[0]
          )
          if (majorPlatformVersion >= 13) {
            return true
          }
        }
      } catch (e) {
        // Fallback: ignore and proceed as not Windows 11
      }
    }
    return false
  }
  return {
    isWindows11
  }
}
